import { render, staticRenderFns } from "./ContentTypeLandingsection.vue?vue&type=template&id=46f37d24&scoped=true&"
import script from "./ContentTypeLandingsection.vue?vue&type=script&lang=js&"
export * from "./ContentTypeLandingsection.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeLandingsection.vue?vue&type=style&index=0&id=46f37d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f37d24",
  null
  
)

export default component.exports